

/* tslint:disable */



export enum TimeSpanType {
    Exact = 0,
    Range = 1,
    Min = 2,
    Max = 3,

}


